import { LastStatusEnum } from "../services/exploreListings";

export const getUpdatedStatus = (lastStatus: LastStatusEnum) => {
	let updatedStatus: { state: string; color: string; desc?: string } = {
		state: "",
		color: "",
		desc: "",
	};

	switch (lastStatus) {
		case LastStatusEnum.Extension:
			updatedStatus = { state: "For Sale", color: "#368014" };
			break;
		case LastStatusEnum.PriceChange:
			updatedStatus = {
				state: "For Sale",
				color: "#368014",
				desc: "Price Changed",
			};
			break;
		case LastStatusEnum.Sold:
			updatedStatus = { state: "SOLD", color: "#FF5757" };
			break;
		case LastStatusEnum.Leased:
			updatedStatus = { state: "LEASED", color: "#FF5757" };
			break;
		case LastStatusEnum.SoldConditionallyWithEscapeClause &&
			LastStatusEnum.SoldConditionally:
			updatedStatus = { state: "Sold Conditional", color: "#FF5757" };
			break;
		case LastStatusEnum.LeasedConditionally:
			updatedStatus = { state: "Leased Conditional", color: "#FECD07" };
			break;
		case LastStatusEnum.DealFellThrough:
			updatedStatus = { state: "Deal Fell Through", color: "#E29304" };
			break;
		case LastStatusEnum.Expired:
			updatedStatus = { state: "Expired", color: "#E0E0E0" };
			break;
		case LastStatusEnum.Suspended:
			updatedStatus = { state: "Suspended", color: "#E0E0E0" };
			break;
		case LastStatusEnum.Terminated:
			updatedStatus = { state: "Terminated", color: "#E0E0E0" };
			break;
		case LastStatusEnum.ComingSoon:
			updatedStatus = { state: "Coming Soon", color: "#76BAFF" };
			break;
		case LastStatusEnum.New:
			updatedStatus = { state: "For Sale", color: "#368014" };
			break;
		default:
			updatedStatus = { state: `${lastStatus}`, color: "black" };
			break;
	}

	return updatedStatus;
};
